import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5609e6cc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row mt-10" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-3" }, null, -1))
const _hoisted_3 = { class: "col-6" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = {
  class: "col-xs-12 col-sm-12 col-md-6 col-lg-6",
  style: {"padding-left":"0px"}
}
const _hoisted_6 = { class: "backCard pr-2" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "fs-4 fw-bold titulo" }, "Dueños", -1))
const _hoisted_8 = { class: "fv-row mb-5" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fs-base fw-bold text-dark" }, [
  /*#__PURE__*/_createTextVNode("¿Único dueño? "),
  /*#__PURE__*/_createElementVNode("small", { class: "text-danger" }, "*")
], -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_11 = { style: {"display":"inline-flex","list-style-type":"none","padding":"0px"} }
const _hoisted_12 = { style: {"margin-right":"10px"} }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fs-base" }, "Si", -1))
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fs-base" }, "No", -1))
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = {
  class: "col-xs-12 col-sm-12 col-md-6 col-lg-6",
  style: {"padding-left":"0px"}
}
const _hoisted_18 = { class: "backCard" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "fs-4 fw-bold titulo" }, "Servicios de agencia", -1))
const _hoisted_20 = { class: "fv-row mb-5" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fs-base fw-bold text-dark" }, [
  /*#__PURE__*/_createTextVNode("¿Cuenta con los servicios de agencia? "),
  /*#__PURE__*/_createElementVNode("small", { class: "text-danger" }, "*")
], -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_23 = { style: {"display":"inline-flex","list-style-type":"none","padding":"0px"} }
const _hoisted_24 = { style: {"margin-right":"10px"} }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fs-base" }, "Si", -1))
const _hoisted_26 = [
  _hoisted_25
]
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fs-base" }, "No", -1))
const _hoisted_28 = [
  _hoisted_27
]
const _hoisted_29 = { class: "col-12 backCard mt-10 mb15Porce" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "fs-4 fw-bold titulo" }, "Descripción adicional", -1))
const _hoisted_31 = { class: "fv-row mb-5" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fs-base ms-5 fw-bold text-dark" }, [
  /*#__PURE__*/_createTextVNode("Descripción "),
  /*#__PURE__*/_createElementVNode("small", { class: "text-danger" }, "*")
], -1))
const _hoisted_33 = { class: "fv-plugins-message-container" }
const _hoisted_34 = { class: "fv-help-block" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _hoisted_10,
                _createElementVNode("ul", _hoisted_11, [
                  _createElementVNode("li", _hoisted_12, [
                    _createElementVNode("button", {
                      type: "button",
                      class: _normalizeClass(["btn", _ctx.dueno == 'Si' ? 'btn-primary' : 'btn-secondary']),
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.cambiarDueno('Si')))
                    }, _hoisted_14, 2)
                  ]),
                  _createElementVNode("li", null, [
                    _createElementVNode("button", {
                      class: _normalizeClass(["btn", _ctx.dueno == 'No' ? 'btn-primary' : 'btn-secondary']),
                      type: "button",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.cambiarDueno('No')))
                    }, _hoisted_16, 2)
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _hoisted_19,
              _createElementVNode("div", _hoisted_20, [
                _hoisted_21,
                _hoisted_22,
                _createElementVNode("ul", _hoisted_23, [
                  _createElementVNode("li", _hoisted_24, [
                    _createElementVNode("button", {
                      type: "button",
                      class: _normalizeClass(["btn", _ctx.servicios == 'Si' ? 'btn-primary' : 'btn-secondary']),
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.cambiarServicios('Si')))
                    }, _hoisted_26, 2)
                  ]),
                  _createElementVNode("li", null, [
                    _createElementVNode("button", {
                      type: "button",
                      class: _normalizeClass(["btn", _ctx.servicios == 'No' ? 'btn-primary' : 'btn-secondary']),
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.cambiarServicios('No')))
                    }, _hoisted_28, 2)
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_29, [
            _createVNode(_component_Form, {
              class: "form",
              id: "kt_descripcion_form",
              onInvalidSubmit: _ctx.onInvalidSubmit,
              onSubmit: _ctx.save,
              "validation-schema": _ctx.descripcionSch,
              ref: "descripcionRef"
            }, {
              default: _withCtx(() => [
                _hoisted_30,
                _createElementVNode("div", _hoisted_31, [
                  _hoisted_32,
                  _createVNode(_component_Field, {
                    class: "form-control form-control-sm form-control-solid fs-base description p-5 m-5",
                    type: "text",
                    name: "descripcion",
                    ref: "descripcion",
                    modelValue: _ctx.initialValues.descripcion,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.initialValues.descripcion) = $event)),
                    autocomplete: "off",
                    placeholder: "Escribe algo más sobre el vehículo",
                    as: "textarea"
                  }, null, 8, ["modelValue"]),
                  _createElementVNode("div", _hoisted_33, [
                    _createElementVNode("div", _hoisted_34, [
                      _createVNode(_component_ErrorMessage, { name: "descripcion" })
                    ])
                  ])
                ])
              ]),
              _: 1
            }, 8, ["onInvalidSubmit", "onSubmit", "validation-schema"])
          ])
        ])
      ]),
      _hoisted_35
    ])
  ]))
}